import React, { useLayoutEffect, useRef, useState } from "react";

import { useQuery } from "@tanstack/react-query";
import { getLotHistory } from "api/lots";
import LoadingOverlay from "components/LoadingOverlay";
import { useParams } from "react-router-dom";
import classNames from "classnames";

export default function LottoHistory() {

    const { lottoId } = useParams();
    const refs = useRef({});
    const [lines, setLines] = useState([]);
    const [hovered, setHovered] = useState(null);

    const { data, isLoading } = useQuery({
        queryKey: ["lotto", lottoId, 'storico'],
        queryFn: () => getLotHistory({ lottoId }),
        enabled: !!lottoId
    });

    const lots = data?.filter(d => d.type === 'history') || [];

    const firstLevel = lots?.filter(item => !item.origins?.some(({ originType }) => originType === 'lots'));
    let levels = [firstLevel];
    let isCurrentLot;
    while (!isCurrentLot) {
        const lastLevel = levels[levels.length - 1];
        let nextLevel = lots?.filter(item => item.origins?.some(origin => lastLevel.some(l => l._id === origin.origin && origin.originType === 'lots')));
        nextLevel = nextLevel?.filter(item => !item.origins?.some(origin => nextLevel.some(l => l._id === origin.origin && origin.originType === 'lots')));
        if (!nextLevel?.length) {
            isCurrentLot = true;
            break;
        }
        levels.push(nextLevel);
    }

    useLayoutEffect(() => {
        let lotsLines = [];
        for (const lot of lots) {
            const { origins = [], _id } = lot || {};
            const lotLines = origins?.map(origin => {
                if (origin.originType !== 'lots') return null;
                const originElement = refs.current[origin.origin];
                const lotElement = refs.current[_id];
                if (!originElement || !lotElement) return null;
                const originRect = originElement.getBoundingClientRect();
                const lotRect = lotElement.getBoundingClientRect();

                const startX = originRect.right;
                const startY = originRect.top + (originRect.height / 2);
                const endX = lotRect.left;
                const endY = lotRect.top + (lotRect.height / 2);

                const midY = (startY + endY) / 2;

                return {
                    lot: _id,
                    startX,
                    startY,
                    endX,
                    endY,
                    midY
                };
            }).filter(line => line !== null);
            lotsLines = [...lotsLines, ...lotLines];
        }
        setLines(lotsLines);
    }, [data]);

    return (
        <div>
            <LoadingOverlay isLoading={isLoading} />
            <div className="flex absolute top-0 left-0 bottom-0 right-0 bg-white z-50 min-h-full min-w-full">
                <div className="min-h-full min-w-full relative flex items-center justify-center p-10 overflow-auto">
                    {levels?.map((level, index) => (
                        <div key={index} className="flex mb-10 justify-center items-center flex-col mx-10">
                            {level?.map((item) => {
                                const Classes = classNames({
                                    "relative w-full block border bg-verylight rounded-[20px] overflow-hidden mb-20 last:mb-0 box-border": true,
                                    "border-green": item._id === lottoId || item._id === hovered?._id,
                                    "border-grey": item._id !== lottoId,
                                    "border-greydark": item._id !== lottoId && (item._id === hovered?._id || hovered?.origins?.some(origin => origin.origin === item._id && origin.originType === 'lots')),
                                    // "border-2": item._id === lottoId || item._id === hovered?._id || hovered?.origins?.some(origin => origin.origin === item._id && origin.originType === 'lots'),
                                });
                                const { product, code, netWeight } = item || {};
                                return (
                                    <div key={item._id} className={Classes} id={item._id} ref={el => refs.current[item._id] = el} onMouseEnter={() => setHovered(item)} onMouseLeave={() => setHovered(null)}>
                                        <div className={`flex gap-3 items-center px-4 py-3`}>
                                            <div className={`flex-1`}>
                                                <div className={`font-medium text-lg`}>{product?.name}</div>
                                                <div className={`font-medium text-sm pb-1`}>{code}</div>
                                            </div>

                                            <div className={`flex items-center justify-between`}>
                                                <div className={`flex items-center gap-4 text-sm`}>
                                                    {netWeight > 0 &&
                                                        <div className='text-right'>
                                                            {/* <p className='text-xs pb-0.5'>Peso netto</p> */}
                                                            <p className='text-xl font-semibold'>{netWeight} kg</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    ))}
                    <div className="absolute top-0 left-0 w-full h-full pointer-events-none index-0">
                        <svg className="w-full h-full">
                            {lines?.map((line, index) => {
                                const color = line.lot === hovered?._id ? "#52555A" : "#D6D6D6";
                                const strokeWidth = 1;
                                return (
                                    <path key={index} d={`M${line.startX},${line.startY} C${line.startX},${line.midY} ${line.endX},${line.midY} ${line.endX},${line.endY}`} stroke={color} strokeWidth={strokeWidth} fill="none" />
                                );
                            })}
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}